import { Text, View, Page } from "@react-pdf/renderer";
import { parseBoldSegments } from "helpers/text";

import { styles } from "../styles";
import { Footer } from "./Footer";
import { Header } from "./Header";

export function PlasticSurgeryText({
  facilityLogo,
  fullAddress,
  phoneNumber,
  facilityName,
  showAddress,
  customTermsAndConditions,
}: {
  facilityLogo: string;
  fullAddress: string;
  phoneNumber: string;
  facilityName: string;
  showAddress: boolean;
  customTermsAndConditions?: string | null;
}) {
  const hasCustomTerms = !!customTermsAndConditions?.trim();
  const termsSegments = hasCustomTerms
    ? parseBoldSegments(customTermsAndConditions ?? "")
    : [];

  return (
    <Page size="LETTER" style={styles.page}>
      <Header
        facilityLogo={facilityLogo}
        fullAddress={fullAddress}
        phoneNumber={phoneNumber}
        showAddress={showAddress}
      />
      <View style={{ ...styles.section, marginTop: 5 }}>
        {hasCustomTerms && (
          <Text style={{ ...styles.bodyText, lineHeight: 1.1 }}>
            {termsSegments.map((segment, index) =>
              segment.bold ? (
                <Text
                  key={index}
                  style={{ fontFamily: "Helvetica-Bold", marginBottom: 2 }}
                >
                  {segment.text}
                </Text>
              ) : (
                <Text key={index}>{segment.text}</Text>
              )
            )}
          </Text>
        )}
      </View>
      <View
        style={{
          marginTop: 20,
          width: "100%",
          marginLeft: 50,
          marginRight: 50,
        }}
      >
        <Text
          style={{
            ...styles.bodyText,
            marginTop: 4,
          }}
        >
          Patient Name Printed: _____________________________
        </Text>
      </View>
      <View
        style={{
          marginTop: 30,
          width: "100%",
          marginLeft: 50,
          marginRight: 50,
          display: "flex",
          flexDirection: "row",
          gap: 20,
        }}
      >
        <Text
          style={{
            ...styles.bodyText,
            marginTop: 4,
          }}
        >
          Patient Signature: _________________________________
        </Text>
        <Text
          style={{
            ...styles.bodyText,
            marginTop: 4,
          }}
        >
          Date: _____________
        </Text>
      </View>
      <Footer facilityName={facilityName} />
    </Page>
  );
}
